import { render, staticRenderFns } from "./QuizGenerator.vue?vue&type=template&id=910a5044&scoped=true&"
import script from "./QuizGenerator.vue?vue&type=script&lang=js&"
export * from "./QuizGenerator.vue?vue&type=script&lang=js&"
import style0 from "./QuizGenerator.vue?vue&type=style&index=0&id=910a5044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910a5044",
  null
  
)

export default component.exports